import { createContext, Dispatch } from 'react'

// TYPES
import { AuthActions, AuthActionTypes, ScreenTransition } from './types'
import type { AuthScreen } from '../'
import type { IToast } from '@components/molecules/toast'


export interface AuthState {
    currentScreen: AuthScreen
    prevScreen?: AuthScreen
    transitionState: ScreenTransition
    /** Time in milliseconds */
    transitionTime: number
    isNewUser: boolean
    toast?: IToast
}

export const initState: AuthState = {
    currentScreen: "sign-in",
    prevScreen: undefined,
    transitionState: "visible",
    transitionTime: 0,
    isNewUser: false,
    toast: undefined,
}

export function AuthReducer(state = initState, action: AuthActionTypes): AuthState {
    switch (action.type) {
        case AuthActions.SET_TOAST:
            return { ...state, toast: action.payload }
        case AuthActions.SET_SCREEN:
            return { ...state, currentScreen: action.payload, prevScreen: state.currentScreen }
        case AuthActions.SET_TRANSITION_STATE:
            return { ...state, transitionState: action.payload }
        case AuthActions.SET_IS_NEW_USER:
            return { ...state, isNewUser: action.payload }
        case AuthActions.RESET:
            return { ...initState }
        default:
            return state
    }
}

export const AuthContext = createContext<{ localState: AuthState, localDispatch: Dispatch<AuthActionTypes> }>({
    localState: initState,
    localDispatch: () => undefined,
})
